module.exports = __webpack_public_path__ + "static/media/file-invoice-dollar.fe187911.svg";